var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import merge from 'lodash.merge';
import useDesign from '../../../../../../../hooks/useDesign';
import { Icon } from '../../../../../../atoms/Icon';
import { TranslatedText } from '../../../../../../atoms/TranslatedText';
import { Link, LogoWrapper, Wrapper } from './styles';
export var Footer = function (_a) {
    var design = _a.design, values = _a.values, t = _a.translations, props = __rest(_a, ["design", "values", "translations"]);
    var _b = useDesign(design), schema = _b.schema, config = _b.config;
    var to = merge({}, config, props).to;
    return (_jsxs(Wrapper, __assign({ schema: schema, "data-design": design, className: "incentive__footer" }, { children: [_jsx(Link, __assign({ to: to, className: "incentive__footer__link", target: "_blank" }, { children: _jsx(TranslatedText, { i18n: t.learnMore, className: "incentive__footer__link__text" }) })), _jsxs(LogoWrapper, __assign({ className: "incentive__footer__logoWrapper" }, { children: [_jsx(TranslatedText, { i18n: t.logoText, className: "incentive__footer__logoText" }), _jsx(Icon, { src: "zappy", as: "img", width: "80", height: "auto", size: "lg" })] }))] })));
};
